import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import Form from '../../../common/Form';
import Input from '../../../common/Form/Input';
import FormTable from '../../../common/Form/Table';
import { useForm } from 'react-hook-form';
import DatePicker from '../../../common/Form/DatePicker';
import Upload from '../../../common/Form/FileUpload';
import { createInvoice } from '../../../actions/payments';

const arrayName = 'invoices';
const formName = 'updatePoInvoice';

const ManualPOInvoice = (props) => {
    const { po } = props;
    const dispatch = useDispatch();
    const formDivRef = useRef(null);
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const defaultValues = {
        [arrayName]: [{ id: `${Math.random()}` }],
    };
    const methods = useForm({ defaultValues, mode: 'all' });




    const onSave = (index) => {
        const values = methods.watch(arrayName)[index];
        const payload = {
            org_id: po.org_id,
            org_gst_number: po.org_gst_number ? po.org_gst_number : undefined,
            customer_id: po.org_id,
            customer_gst_number: po.vendor_gst_number ? po.vendor_gst_number : undefined,
            item: 'PO',
            currency: 'INR',
            invoice_number: values.invoiceNumber,
            invoice_date: values.invoiceDate,
            external_po_number: values.customerPoNumber,
            is_recurring: false,
        }
        dispatch(createInvoice({ payload, formName }));
    }

    const closeModal = () => {
        dispatch(closeModalAction());
    };

    const schema = {
        table: [
            {
                head: {
                    thClassName: `pl-2 w-60`,
                    headName: 'Invoice Number',
                    required: true,
                },
                body: {
                    bodyClassName: `pl-1 w-60`,
                    render: (_, { rowIndex }) => (
                        <div>
                            <Input name={`${arrayName}[${rowIndex}].invoiceNumber`} type='text' required placeholder='Invoice Number' />
                        </div>
                    ),
                },
            },
            {
                head: {
                    thClassName: `w-60`,
                    headName: 'Invoice Date',
                    required: true,
                },
                body: {
                    bodyClassName: `w-60`,
                    render: (_, { rowIndex }) => (
                        <div>
                            <DatePicker name={`${arrayName}[${rowIndex}].invoiceDate`} required placeholder='Invoice Date' padding={''} />
                        </div>
                    ),
                },
            },
            {
                head: {
                    thClassName: `w-60 pl-2`,
                    headName: 'Quantity',
                },
                body: {
                    name: 'quantity',
                    bodyClassName: `w-60`,
                    render: (_, { rowIndex }) => (
                        <div>
                            <Input name={`${arrayName}[${rowIndex}].quantity`} type='number' placeholder='Quantity' />
                        </div>
                    ),
                },
            },
            {
                head: {
                    thClassName: `w-60 pl-2`,
                    headName: 'Amount',
                },
                body: {
                    bodyClassName: `w-60`,
                    allowFloats: true,
                    render: (_, { rowIndex }) => (
                        <div>
                            <Input name={`${arrayName}[${rowIndex}].amount`} type='number' step='any' placeholder='Amount' />
                        </div>
                    ),
                },
            },
            {
                head: {
                    thClassName: `w-60 pl-2`,
                    headName: 'Customer PO',
                },
                body: {
                    bodyClassName: `w-60`,
                    render: (_, { rowIndex }) => (
                        <div>
                            <Input name={`${arrayName}[${rowIndex}].customerPoNumber`} type='text' placeholder='Customer PO' />
                        </div>
                    ),
                },
            },
            {
                head: {
                    thClassName: `w-60 pl-2`,
                    headName: 'Attachments',
                },
                body: {
                    bodyClassName: `w-60`,
                    render: (_, { rowIndex }) => (
                        <div>
                            <Upload name={`${arrayName}[${rowIndex}].attachments`} isMulti placeholder='Attachments' />
                        </div>
                    ),
                },
            },
            {
                head: {
                    thClassName: `w-40`,
                    headName: 'Actions',
                },
                body: {
                    bodyClassName: `w-40 pl-2`,
                    render: (_, { rowIndex, remove }) => {
                        return (
                            <div className='flex justify-center'>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onSave(rowIndex);
                                    }}
                                    className="flex items-center gap-1 px-2 py-0 bg-scogoprimary text-white rounded-md hover:bg-scogoprimary-dark transition-colors text-xs"
                                >
                                    <span className="material-icons text-font12">save</span>
                                    <span>Save</span>
                                </button>
                                <span
                                    onClick={(e) => {
                                        e.preventDefault();
                                        remove(rowIndex);
                                    }}
                                    className={`material-icons text-scogoToastDangerIcon cursor-pointer hover:text-scogoorange`}
                                >
                                    delete
                                </span>
                            </div>
                        );
                    },
                },
            },
        ],
    };


    return (
        <div ref={formDivRef}>
            <Form
                className='w-full'
                onSubmit={() => { }}
                onCancel={closeModal}
                methods={methods}
            >
                <div style={{ padding: '1.25rem' }}>
                    <FormTable isLoading={false} schema={schema} name={arrayName} allowAdd addButtonClassName='my-2' rowGenerator={() => ({ id: `${Math.random()}` })} />
                </div>
            </Form>
        </div>
    );
};

export default ManualPOInvoice;
